import { FC } from 'react';

import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';

import { TypeAccountERCTranslations } from '@/utils/translations/types/TypeAccountERCTranslations';

import { UpsellCard } from '../../_components/UpsellCard';

export type LayoutNoSubscriptionProps = {
  t: TypeAccountERCTranslations;
  subscriptionId: string;
};

const LayoutCancelledSubscription: FC<LayoutNoSubscriptionProps> = ({
  t,
  subscriptionId,
}) => (
  <div
    data-testid="layout-cancelled-subscription"
    className="text-center px-6 md:px-8"
  >
    <Heading
      tag={HeadingTag.H1}
      size={HeadingSize.H1}
      classes="pb-6"
      align="left"
      text={t.cancelledSubscriptionTitle}
    />

    <UpsellCard
      headerText={t.cancelledSubscriptionCardTitle}
      subText={t.cancelledSubscriptionCardSubText}
      ctaText={t.cancelledSubscriptionCtaText}
      ctaLink={`/account/early-reader-club/${subscriptionId}/reactivate`}
    />
  </div>
);

export default LayoutCancelledSubscription;
